export default {"src":"/_next/static/media/VIC-card-number-post-07-nov-2022.bceb576b.svg","height":142,"width":222,"blurWidth":0,"blurHeight":0};